import svgConnect from "../../../../assets/imgs/socials/connects/facebook.svg";
import svgNaoConectado from "../../../../assets/imgs/socials/notConnects/facebook.svg";

import MyImage from "../../../myImage"

const MyIconFacebook = ({sx, connect}) =><MyImage src={connect ? svgConnect : svgNaoConectado} alt={'facebook icon'} sx={sx} />

export default MyIconFacebook;
